if (!window.hasOwnProperty('coreModules')) {
    window.coreModules = {};
}

window.coreModules.Dialog = function() {
    var self = this;
    var templates = {};
    var callback = function() {};
    var callback2 = function() {};
    
    self.getTemplate = function(name, callback) {
        if (!templates.hasOwnProperty(name)) {
            $.get('/tpls/' + name + '.html?v=' + window.version, function(response) {
                templates[name] = response;
                callback(templates[name]);
            });
        } else {
            callback(templates[name]);
        }
    };
    
    self.show = function(name, data, cb, cb2, backdrop = true, keyboard = true) {
        callback = typeof cb === 'function' ? cb : function(){};
        callback2 = typeof cb2 === 'function' ? cb2 : function(){};
        var $el = $('#' + name + '-modal');
        if ($el.length > 0) {
            $el.remove();
        }
        
        self.getTemplate(name, function (template) {
            var html = self.templater.render(template, data);
            $('body').append(html);
            $('#' + name + '-modal').modal({backdrop: backdrop, keyboard: keyboard, show: true});
            callback2();
        });
    };
    
    self.hide = function(name) {
        $('#' + name + '-modal').modal('hide');
        callback();
    };
};